<template>
    <v-container fluid>
        <v-row class="mb-2">
            <v-col cols="12" sm="6" xs="6" md="12" lg="3">
                <slot name="breadcrumbs" class="py-4"></slot>
            </v-col>
        </v-row>
        
        <!-- settings -->
        <v-row dense class="px-0 ma-0">
            <v-col v-for="(setting, index) in settings" :key="index" xl="3" lg="4" sm="6" cols="12">
                <v-card class="rounded-medium">
                    <v-card-text class="pa-0" :class="setting.imageClass">                    
                        <v-img
                            v-if="setting.type === 'switch'"
                            contain
                            height="150"
                            :src="options[setting.VModelKey] ? setting.activeImage : setting.deactivateImage"
                        ></v-img>
                        <v-img
                            v-if="setting.type === 'radio'"
                            contain
                            height="150"
                            :src="setting.images[radio]"
                        >
                        </v-img>
                    </v-card-text>
                    <v-card-actions class="pa-0">
                        <v-expansion-panels flat hover>
                            <v-expansion-panel active-class="rounded-medium">
                                <v-expansion-panel-header class="px-4 primary--text">
                                    {{setting.title}}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="mx-n2">
                                    <v-switch 
                                        v-if="setting.type === 'switch'"
                                        v-model="options[setting.VModelKey]"
                                        :label="setting.switchLabel"
                                        inset
                                        dense
                                        hide-details
                                        class="pt-0 mt-0 text-start"
                                    ></v-switch>
                                    <v-radio-group
                                    v-if="setting.type === 'radio'"
                                    v-model="radio"
                                    row
                                    class="pt-0 text-start"
                                    >
                                        <v-radio
                                        label="كلاهما"
                                        :value="postingType.both"
                                        ></v-radio>
                                        <v-radio
                                        label="المحاسب اولا"
                                        :value="postingType.bond"
                                        ></v-radio>
                                        <v-radio
                                        label="عاملي المستودع اولا"
                                        :value="postingType.materialsJournal"
                                        >

                                    </v-radio>
                                </v-radio-group>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ls from '@/settings/localStorageExtension'
import { postingType } from '@/helpers/enums'
import { mapState } from 'vuex'
export default {
    data(){
        return{
            options: {
                visibleSymbolMoney: ls.getVisibleSymbolMoney(),
                askBeforeBondCreation: ls.getAskBeforeBondCreation(),
                openAccountStatementInNewWindow: JSON.parse(localStorage.getItem('openAccountStatementInNewWindow'))
            },
            postingType,
            radio: 0
        };
    },
    watch:{
        'options.visibleSymbolMoney'(val) { ls.setVisibleSymbolMoney(val); },
        'options.askBeforeBondCreation'(val) { ls.setAskBeforeBondCreation(val) },
        'options.openAccountStatementInNewWindow'(val) {
            localStorage.setItem('openAccountStatementInNewWindow', val);
        },
    },
    computed: {
        ...mapState({
            postingSetting: state => state.settings.postingType
        }),
        settings() {
            return [
                {
                    activeImage: require('@/assets/treasure-primary-show.png'),
                    deactivateImage: require('@/assets/treasure-hide.png'),
                    title: this.$t('publicSettingsPage.currencies-settings'),
                    switchLabel: this.$t('publicSettingsPage.show-currency-symbol'),
                    VModelKey: 'visibleSymbolMoney',
                    type: 'switch'
                },
                {
                    activeImage: require('@/assets/create-bond.png'),
                    deactivateImage: require('@/assets/create-bond-hide.png'),
                    title: this.$t('publicSettingsPage.Asking-about-the-date-of-the-bond-accounting-or-cash-before-it-was-created'),
                    switchLabel: this.$t('publicSettingsPage.show-the-dialog-to-choose-the-date-instead-of-adopting-today-date'),
                    VModelKey: 'askBeforeBondCreation',
                    imageClass: 'dark-background',
                    type: 'switch'
                },
                {
                    activeImage: require('@/assets/multi-window-statement.png'),
                    deactivateImage: require('@/assets/one-window-statement.png'),
                    title: this.$t('publicSettingsPage.open-account-statement-in-new-window'),
                    switchLabel: this.$t('publicSettingsPage.opening-account-statement-in-new-window-from-accounting-journal'),
                    VModelKey: 'openAccountStatementInNewWindow',
                    type: 'switch'
                },
                // {
                //     images:[require('@/assets/taxation.png'),require('@/assets/accounting.png'),require('@/assets/material-management.png')],
                //     title: this.$t('publicSettingsPage.posting-type'),
                //     switchLabel: this.$t('publicSettingsPage.posting-type'),
                //     VModelKey: '',
                //     type:'radio'
                // },
            ]
        },
    },
    methods: {
    }
}
</script>

<style scoped>
.dark-background {
    background-color: #001D26
}
</style>
